import { render, staticRenderFns } from "./WithdrawBurn.vue?vue&type=template&id=520b1854&"
import script from "./WithdrawBurn.vue?vue&type=script&lang=js&"
export * from "./WithdrawBurn.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawBurn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports